var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIconMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu_3388694",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39809",
    "data-name": "Path 39809",
    d: "M10.788,3H2.041A2.043,2.043,0,0,0,0,5.041V7.289A2.043,2.043,0,0,0,2.041,9.33h8.747a2.043,2.043,0,0,0,2.041-2.041V5.041A2.043,2.043,0,0,0,10.788,3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39810",
    "data-name": "Path 39810",
    d: "M10.788,10H2.041A2.043,2.043,0,0,0,0,12.041v9.246a2.043,2.043,0,0,0,2.041,2.041h8.747a2.043,2.043,0,0,0,2.041-2.041V12.041A2.043,2.043,0,0,0,10.788,10Z",
    transform: "translate(0 1.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39811",
    "data-name": "Path 39811",
    d: "M23.788,16H15.041A2.043,2.043,0,0,0,13,18.041v2.248a2.043,2.043,0,0,0,2.041,2.041h8.747a2.043,2.043,0,0,0,2.041-2.041V18.041A2.043,2.043,0,0,0,23.788,16Z",
    transform: "translate(2.171 2.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39812",
    "data-name": "Path 39812",
    d: "M23.788,3H15.041A2.043,2.043,0,0,0,13,5.041v9.246a2.043,2.043,0,0,0,2.041,2.041h8.747a2.043,2.043,0,0,0,2.041-2.041V5.041A2.043,2.043,0,0,0,23.788,3Z",
    transform: "translate(2.171)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIconMenu);
export default __webpack_public_path__ + "static/media/dashboard_icon_menu.e63205953293157183f5562f9eee0f36.svg";
export { ForwardRef as ReactComponent };